import { render } from "./QuickpayCGV.vue?vue&type=template&id=65397240&scoped=true"
import script from "./QuickpayCGV.vue?vue&type=script&lang=js"
export * from "./QuickpayCGV.vue?vue&type=script&lang=js"

import "./QuickpayCGV.vue?vue&type=style&index=0&id=65397240&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65397240"]])

export default __exports__